import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlaceholderLoaderComponent } from './components/placeholder-loader/placeholder-loader.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [PlaceholderLoaderComponent],
  exports: [PlaceholderLoaderComponent]
})
export class PlaceholderLoaderModule { }
